// @ts-nocheck
import { orderStatus } from '@/constants';
import { mergeOrder } from '@/utils';
const ACCEPT_STATUS_CODE = [
    orderStatus.ACCEPTED.code,
    orderStatus.WORKER_REQUESTED.code,
];
const ACCEPT_STATUS_CODE_FOR_EVENT = [
    orderStatus.ALLOCATED.code,
    orderStatus.CANCELED.code,
    orderStatus.NONE.code,
];
const ALLOCATE_STATUS_CODE = [
    orderStatus.ALLOCATED.code,
    orderStatus.PICKUP_ARRIVED.code,
];
const ALLOCATE_STATUS_CODE_FOR_EVENT = [
    orderStatus.ACCEPTED.code,
    orderStatus.PICKUP_FINISHED.code,
    orderStatus.CANCELED.code,
];
const PICKUP_STATUS_CODE = [
    orderStatus.PICKUP_FINISHED.code,
];
const PICKUP_STATUS_CODE_FOR_EVENT = [
    orderStatus.ACCEPTED.code,
    orderStatus.DROP_FINISHED.code,
    orderStatus.CANCELED.code,
];
export default {
    acceptOrderList: (state) => Object.values(state.orderTable.accept)
        .filter((it) => it)
        .filter(({ statusCode }) => [
        ...ACCEPT_STATUS_CODE,
        ...ACCEPT_STATUS_CODE_FOR_EVENT,
    ].includes(statusCode)),
    allocateOrderList: (state) => Object.values(state.orderTable.allocate)
        .filter((it) => it)
        .filter(({ statusCode }) => [
        ...ALLOCATE_STATUS_CODE,
        ...ALLOCATE_STATUS_CODE_FOR_EVENT,
    ].includes(statusCode)),
    pickupOrderList: (state) => Object.values(state.orderTable.pickup)
        .filter((it) => it)
        .filter(({ statusCode }) => [
        ...PICKUP_STATUS_CODE,
        ...PICKUP_STATUS_CODE_FOR_EVENT,
    ].includes(statusCode)),
    searchAcceptOrderList: (state, getters, rootState, rootGetters) => {
        const searchOrder = rootGetters['app/searchOrder'];
        return searchOrder(getters.acceptOrderList
            .filter(({ statusCode }) => ACCEPT_STATUS_CODE.includes(statusCode)));
    },
    searchAllocateOrderList: (state, getters, rootState, rootGetters) => {
        const searchOrder = rootGetters['app/searchOrder'];
        return searchOrder(getters.allocateOrderList
            .filter(({ statusCode }) => ALLOCATE_STATUS_CODE.includes(statusCode)));
    },
    searchPickupOrderList: (state, getters, rootState, rootGetters) => {
        const searchOrder = rootGetters['app/searchOrder'];
        return searchOrder(getters.pickupOrderList
            .filter(({ statusCode }) => PICKUP_STATUS_CODE.includes(statusCode)));
    },
    acceptOrderCount: (state, getters, rootState, rootGetters) => {
        const searchQuery = rootGetters['app/searchQuery'];
        if (searchQuery) {
            return getters.searchAcceptOrderList.length;
        }
        const acceptOrder = mergeOrder(state.orderTable.accept, state.pendingOrder);
        return Object.values(acceptOrder)
            .filter((it) => it)
            .filter(({ statusCode }) => ACCEPT_STATUS_CODE.includes(statusCode))
            .length;
    },
    allocateOrderCount: (state, getters, rootState, rootGetters) => {
        const searchQuery = rootGetters['app/searchQuery'];
        if (searchQuery) {
            return getters.searchAllocateOrderList.length;
        }
        const allocateOrder = mergeOrder(state.orderTable.allocate, state.pendingOrder);
        return Object.values(allocateOrder)
            .filter((it) => it)
            .filter(({ statusCode }) => ALLOCATE_STATUS_CODE.includes(statusCode))
            .length;
    },
    pickupOrderCount: (state, getters, rootState, rootGetters) => {
        const searchQuery = rootGetters['app/searchQuery'];
        if (searchQuery) {
            return getters.searchPickupOrderList.length;
        }
        const pickupOrder = mergeOrder(state.orderTable.pickup, state.pendingOrder);
        return Object.values(pickupOrder)
            .filter((it) => it)
            .filter(({ statusCode }) => PICKUP_STATUS_CODE.includes(statusCode))
            .length;
    },
    allocatedDistributorId: (state) => state.order?.allocatedDistributorId,
    allocatedHubName: (state) => state.order?.allocatedHubName,
    allocatedWorkerCode: (state) => state.order?.allocatedWorkerCode,
    allocatedWorkerName: (state) => state.order?.allocatedWorkerName,
    allocatedHubId: (state) => state.order?.allocatedHubId,
    distributorId: (state) => state.order?.distributorId,
    orderId: (state) => state.order?.orderId,
    storeId: (state) => state.order?.storeId,
    storeName: (state) => state.order?.storeName,
    hubId: (state) => state.order?.hubId,
    hubName: (state) => state.order?.hubName,
    statusCode: (state) => state.order?.statusCode,
};
